import axios from 'axios'

export default {
    checkResponse(response) {
        if (response) {
            if (!!response.data.deactivated) {
                if (window.location.pathname != '/login') {
                    return window.location.href = '/login';
                }
            } else {
                return response.data
            }
        } else {
            toastr['error']('Ошибка', 'Ошибка');

            return window.location.href = '/login';
        }
    },
    getData(page, sort, pageSize, filters) {
        var url = '/data/list?page=' + page
            + '&sortBy=' + sort.sortBy
            + '&sortDesc=' + sort.sortDesc
            + '&pageSize=' + pageSize
            + '&dateStart=' + filters.secondDateRange.start
            + '&dateEnd=' + filters.secondDateRange.end
            + '&start=' + filters.range.start
            + '&end=' + filters.range.end
            + '&user=' + filters.userArray
            + '&search=' + filters.searchArray
            + '&source=' + filters.sourceArray
            + '&isTest=' + filters.isTest
            + '&selectedPartnerId=' + filters.selectedPartnerId
            + '&selectedSub1=' + filters.selectedSub1 + '&selectedSub2=' + filters.selectedSub2
            + '&selectedSub3=' + filters.selectedSub3 + '&selectedSub4=' + filters.selectedSub4
            + '&type=' + filters.type;

        return axios.get(url)
            .then(response => {

                return this.checkResponse(response)
            })
    },
    deleteData(id) {

        return axios.post('/data/delete/' + id)
            .then(response => {

                return this.checkResponse(response)
            })
    },
    updateData(data) {

        return axios.post('/data/update/' + data.id, data)
            .then(response => {

                return this.checkResponse(response)
            })
    },
    save(data) {
        return axios.post('/data/save', data)
            .then(response => {

                return this.checkResponse(response)
            })
    },
    update(data) {
        return axios.post('/data/update/' + data.id, data)
            .then(response => {

                return this.checkResponse(response)
            })
    }
}



// WEBPACK FOOTER //
// ./resources/js/services/dataDataService.js